import { GRR_DRAFT, GRR_SIGNED_BY_REF } from '../constants/statusCodes';
import {
    ADDING_PLAYERS_TO_ROSTER_FAILED,
    ADDING_PLAYERS_TO_ROSTER_SUCCEEDED,
    CONFIRMING_GAME_REPORT_REFEREE_SUCCEEDED,
    CONFIRMING_ROSTER_PLAYERS_SUCCEEDED,
    EDITING_ROSTER_PLAYER_FAILED,
    EDITING_ROSTER_PLAYERS_FAILED,
    EDITING_ROSTER_PLAYER_SUCCEEDED,
    EDITING_ROSTER_PLAYERS_SUCCEEDED,
    LOADING_GAME_REPORT_REFEREE_FAILED,
    LOADING_GAME_REPORT_REFEREE_SUCCEEDED,
    LOADING_GAMES_FAILED,
    LOADING_GAMES_SUCCEEDED,
    LOADING_ELIGIBLE_PLAYERS_FAILED,
    LOADING_ELIGIBLE_PLAYERS_SUCCEEDED,
    LOADING_ELIGIBLE_TEAM_OFFICIALS_FAILED,
    LOADING_ELIGIBLE_TEAM_OFFICIALS_SUCCEEDED,
    LOADING_EXTENDED_ELIGIBLE_PLAYERS_FAILED,
    LOADING_EXTENDED_ELIGIBLE_PLAYERS_SUCCEEDED,
    LOADING_EXTENDED_ELIGIBLE_TEAM_OFFICIALS_FAILED,
    LOADING_EXTENDED_ELIGIBLE_TEAM_OFFICIALS_SUCCEEDED,
    LOADING_REFEREES_FAILED,
    LOADING_REFEREES_SUCCEEDED,
    LOADING_ROSTERS_FAILED,
    LOADING_ROSTERS_SUCCEEDED,
    LOADING_SEASONS_FAILED,
    LOADING_SEASONS_SUCCEEDED,
    LOGOUT_FAILED,
    LOGOUT_SUCCEEDED,
    REMOVING_ROSTER_PLAYER_FAILED,
    REMOVING_ROSTER_PLAYER_SUCCEEDED,
    SAVING_GAME_REPORT_REFEREE_DRAFT_SUCCEEDED,
    SET_ACTIVE_GAME,
    SET_ACTIVE_SEASON,
    SETTING_ROSTER_STATUS_SUCCEEDED,
    SIGNING_GAME_REPORT_REFEREE_SUCCEEDED,
    SIGNING_SUPPLEMENTARY_SUCCEEDED,
    TAKING_FACE_CHECK_SUCCEEDED,
    PUBLISHING_ROSTER_SUCCEEDED,
    OVERWRITING_GAME_REPORT_REFEREE_SUCCEEDED
} from '../constants/actionTypes';
import { CAPTAIN_C, POSITION_HEAD_COACH } from '../constants/misc';
import { parseKey, reduceLoadingEligiblesFailed, reduceLoadingEligiblesSucceeded } from '../../util/reducer-helpers';
import { supports } from '../../util/context';
import { deepCopy } from '../../util';

const defaultItems = {
    activeItem: null,
    items:      null,
    lastUpdate: null
};

const initialState = {
    gameReportsReferee:            {},
    games:                         { ...defaultItems },
    eligiblePlayers:               {},
    eligibleTeamOfficials:         {},
    extendedEligiblePlayers:       {},
    extendedEligibleTeamOfficials: {},
    referees:                      {},
    rosters:                       {},
    seasons:                       { ...defaultItems }
};

const reducer = ( state = initialState, action ) => {

    // console.log( 'reducers.items', state, action );

    const lastUpdate = ( new Date() ).toJSON();

    switch ( action.type ) {

        case ADDING_PLAYERS_TO_ROSTER_FAILED: {

            // TODO save in localChanges

            return state;

        }

        case ADDING_PLAYERS_TO_ROSTER_SUCCEEDED: {

            const { context, gameId, team, players } = action.payload;
            const rosters                            = { ...state.rosters };

            rosters[ gameId ].items[ team + 'Roster' ].push( ...players );

            if ( supports( context, 'teamOfficials' ) ) {

                const teamOfficials = action.payload.teamOfficials;

                if ( ! rosters[ gameId ].items[ team + 'TeamOfficials' ] ) {

                    rosters[ gameId ].items[ team + 'TeamOfficials' ] = [];

                }

                rosters[ gameId ].items[ team + 'TeamOfficials' ].push( ...teamOfficials );

            }

            return { ...state, rosters };

        }

        case CONFIRMING_GAME_REPORT_REFEREE_SUCCEEDED: {

            const { gameId, gameReportReferee, username } = action.payload;
            const gameReportsReferee                      = { ...state.gameReportsReferee };
            const meta                                    = ( gameId in gameReportsReferee ) ? gameReportsReferee[ gameId ].meta : null;
                  gameReportsReferee[ gameId ]            = { gameReportReferee, meta: { ...meta, status: GRR_SIGNED_BY_REF, statusChangedAt: lastUpdate, statusChangedBy: username }, lastUpdate };

            return { ...state, gameReportsReferee };

        }

        case SIGNING_GAME_REPORT_REFEREE_SUCCEEDED: {

            const { gameId, team, comment, name, username } = action.payload;
            const gameReportsReferee                        = { ...state.gameReportsReferee };
            const gameReportReferee                         = { ...gameReportsReferee[ gameId ].gameReportReferee };
            const meta                                      = { ...gameReportsReferee[ gameId ].meta };
            const key                                       = 'notes' + ( team === 'home' ? 'Home' : 'Away' );

            gameReportReferee[ key ].comment = comment;
            gameReportReferee[ key ].name    = name;
            meta[ team + 'ConfirmationAt' ]  = lastUpdate;
            meta[ team + 'ConfirmationBy' ]  = username;
            gameReportsReferee[ gameId ]     = { gameReportReferee, meta, lastUpdate };

            return { ...state, gameReportsReferee };

        }

        case OVERWRITING_GAME_REPORT_REFEREE_SUCCEEDED: {

            const { gameId, gameReportReferee } = action.payload;
            const gameReportsReferee                      = { ...state.gameReportsReferee };
            const meta                                    = ( gameId in gameReportsReferee ) ? { ...gameReportsReferee[ gameId ].meta } : null;
                  gameReportsReferee[ gameId ]            = { gameReportReferee, meta, lastUpdate };

            return { ...state, gameReportsReferee };

        }

        case CONFIRMING_ROSTER_PLAYERS_SUCCEEDED: {

            const { data, gameId } = action.payload;
            const rosters          = { ...state.rosters };

            if ( rosters && ( gameId in rosters ) && rosters[ gameId ].items ) {

                rosters[ gameId ].items = { ...rosters[ gameId ].items, ...data };

            }

            return { ...state, rosters };

        }

        case EDITING_ROSTER_PLAYER_FAILED: {

            // TODO save in localChanges

            return state;

        }

        case EDITING_ROSTER_PLAYERS_FAILED: {

            // do nothing

            return state;

        }

        case EDITING_ROSTER_PLAYER_SUCCEEDED: {

            const { gameId, team, player } = action.payload;
            const rosters                  = { ...state.rosters };
            const items                    = rosters[ gameId ].items[ team + ( player.isTeamOfficial ? 'TeamOfficials' : 'Roster' ) ];

            items.splice( items.findIndex( rosterPlayer => rosterPlayer.id === player.id ), 1, { ...player } );

            if ( player.isTeamOfficial && player.lineupData.job === POSITION_HEAD_COACH ) {

                let existingHeadCoach = items.find( e => {

                    parseKey( e, 'lineupData' );

                    return e.id !== player.id && e.lineupData.job === POSITION_HEAD_COACH;

                } );

                if ( existingHeadCoach ) {

                    existingHeadCoach = { ...existingHeadCoach, lineupData: { ...existingHeadCoach.lineupData, job: null } };

                    items.splice( items.findIndex( rosterPlayer => rosterPlayer.id === existingHeadCoach.id ), 1, existingHeadCoach );

                }

            } else if ( ! player.isTeamOfficial && player.lineupData.captain === CAPTAIN_C ) {

                let existingCaptain = items.find( e => {

                    parseKey( e, 'lineupData' );

                    return e.id !== player.id && e.lineupData.captain === CAPTAIN_C;

                } );

                if ( existingCaptain ) {

                    existingCaptain = { ...existingCaptain, lineupData: { ...existingCaptain.lineupData, captain: null } };

                    items.splice( items.findIndex( rosterPlayer => rosterPlayer.id === existingCaptain.id ), 1, existingCaptain );

                }

            }

            return { ...state, rosters };

        }

        case EDITING_ROSTER_PLAYERS_SUCCEEDED: {

            const { gameId, team, players } = action.payload;
            const rosters                   = deepCopy( state.rosters );
            const items                     = rosters[ gameId ].items[ team + 'Roster' ];

            players.forEach( e => {

                const player = items.find( item => item.id === e.playerId );

                if ( player ) {

                    player.lineupData = e.lineupData;

                } else {

                    console.log( 'player not found!', e, items );

                }

            } );

            return { ...state, rosters };

        }

        case LOADING_ELIGIBLE_PLAYERS_SUCCEEDED: {

            return reduceLoadingEligiblesSucceeded( action, state, lastUpdate, 'eligiblePlayers' );

        }

        case LOADING_ELIGIBLE_PLAYERS_FAILED: {

            return reduceLoadingEligiblesFailed( action, state, lastUpdate, 'eligiblePlayers' );

        }

        case LOADING_ELIGIBLE_TEAM_OFFICIALS_SUCCEEDED: {

            return reduceLoadingEligiblesSucceeded( action, state, lastUpdate, 'eligibleTeamOfficials' );

        }

        case LOADING_ELIGIBLE_TEAM_OFFICIALS_FAILED: {

            return reduceLoadingEligiblesFailed( action, state, lastUpdate, 'eligibleTeamOfficials' );

        }

        case LOADING_EXTENDED_ELIGIBLE_PLAYERS_SUCCEEDED: {

            return reduceLoadingEligiblesSucceeded( action, state, lastUpdate, 'extendedEligiblePlayers' );

        }

        case LOADING_EXTENDED_ELIGIBLE_PLAYERS_FAILED: {

            return reduceLoadingEligiblesFailed( action, state, lastUpdate, 'extendedEligiblePlayers' );

        }

        case LOADING_EXTENDED_ELIGIBLE_TEAM_OFFICIALS_SUCCEEDED: {

            return reduceLoadingEligiblesSucceeded( action, state, lastUpdate, 'extendedEligibleTeamOfficials' );

        }

        case LOADING_EXTENDED_ELIGIBLE_TEAM_OFFICIALS_FAILED: {

            return reduceLoadingEligiblesFailed( action, state, lastUpdate, 'extendedEligibleTeamOfficials' );

        }

        case LOADING_GAME_REPORT_REFEREE_FAILED: {

            const { gameId }         = action.payload;
            const gameReportsReferee = { ...state.gameReportsReferee };
            const gameReportReferee  = ( gameId in gameReportsReferee ) ? gameReportsReferee[ gameId ] : null;

            gameReportsReferee[ gameId ] = { ...gameReportReferee, lastUpdate };

            return { ...state, gameReportsReferee };

        }

        case LOADING_GAME_REPORT_REFEREE_SUCCEEDED: {

            const { gameId, data }  = action.payload;
            const gameReportReferee = JSON.parse( data.reportJson || null );
            const meta              = {

                awayConfirmationAt: data.awayConfirmationAt,
                awayConfirmationBy: data.awayConfirmationBy,
                editLevel:          data.editLevel || 0,
                homeConfirmationAt: data.homeConfirmationAt,
                homeConfirmationBy: data.homeConfirmationBy,
                status:             data.status || GRR_DRAFT,
                statusChangedAt:    data.statusChangedAt,
                statusChangedBy:    data.statusChangedBy

            };

            const gameReportsReferee            = { ...state.gameReportsReferee         };
                  gameReportsReferee[ gameId ]  = { gameReportReferee, meta, lastUpdate };

            return { ...state, gameReportsReferee };

        }

        case LOADING_GAMES_SUCCEEDED: {

            return { ...state, games: { ...state.games, items: action.payload.games, lastUpdate, activeItem: action.payload.games.find( e => state.games.activeItem && state.games.activeItem.id === e.id ) } };

        }

        case LOADING_GAMES_FAILED: {

            return { ...state, games: { ...state.games, lastUpdate } };

        }

        case LOADING_REFEREES_FAILED: {

            const { gameId } = action.payload;
            const referees   = { ...state.referees };
            const items      = ( gameId in referees ) ? referees[ gameId ].items : null;

            referees[ gameId ] = { items, lastUpdate };

            return { ...state, referees };

        }

        case LOADING_REFEREES_SUCCEEDED: {

            const { gameId }  = action.payload;
            const referees    = action.payload.referees.map( e => {

                e.label = e.Lastname + ' ' + e.Firstname;
                e.value = e.Lastname + ' ' + e.Firstname;

                return e;

            } );

            const newReferees           = { ...state.referees };
                  newReferees[ gameId ] = { items: referees, lastUpdate };

            return { ...state, referees: newReferees };

        }

        case LOADING_ROSTERS_SUCCEEDED: {

            const { gameId, rosters }  = action.payload;
            const newRosters           = { ...state.rosters };
                  newRosters[ gameId ] = { items: rosters, lastUpdate };

            return { ...state, rosters: newRosters };

        }

        case LOADING_ROSTERS_FAILED: {

            const { gameId }           = action.payload;
            const items                = ( gameId in state.rosters ) ? state.rosters[ gameId ].items : null;
            const newRosters           = { ...state.rosters };
                  newRosters[ gameId ] = { items, lastUpdate };

            return { ...state, rosters: newRosters };

        }

        case LOADING_SEASONS_SUCCEEDED: {

            return { ...state, seasons: { ...state.seasons, items: action.payload.seasons, lastUpdate } };

        }

        case LOADING_SEASONS_FAILED: {

            return { ...state, seasons: { ...state.seasons, lastUpdate } };

        }

        case LOGOUT_FAILED:
        case LOGOUT_SUCCEEDED: {

            return initialState;

        }

        case PUBLISHING_ROSTER_SUCCEEDED: {

            const { gameId, team, publish }                          = action.payload;
            const rosters                                            = { ...state.rosters };
                  rosters[ gameId ].items[ team + 'RosterIsPublic' ] = publish;

            return { ...state, rosters };

        }

        case REMOVING_ROSTER_PLAYER_FAILED: {

            // TODO save in localChanges

            return state;

        }

        case REMOVING_ROSTER_PLAYER_SUCCEEDED: {

            const { gameId, team, playerId, isTeamOfficial } = action.payload;
            const key                                        = team + ( isTeamOfficial ? 'TeamOfficials' : 'Roster' );
            const rosters                                    = { ...state.rosters };
                  rosters[ gameId ].items[ key ]             = rosters[ gameId ].items[ key ].filter( player => player.id !== playerId );

            return { ...state, rosters };

        }

        case SAVING_GAME_REPORT_REFEREE_DRAFT_SUCCEEDED: {

            const { gameId, gameReportReferee } = action.payload;
            const gameReportsReferee            = { ...state.gameReportsReferee };
                  gameReportsReferee[ gameId ]  = { gameReportReferee, lastUpdate };

            return { ...state, gameReportsReferee };

        }

        case SET_ACTIVE_GAME: {

            return { ...state, games: { ...state.games, activeItem: action.payload.game } };

        }

        case SET_ACTIVE_SEASON: {

            return { ...state, seasons: { ...state.seasons, activeItem: action.payload.season } };

        }

        case SETTING_ROSTER_STATUS_SUCCEEDED: {

            const { gameId, rosterStatus } = action.payload;
            const games                    = { ...state.games };
            const rosters                  = { ...state.rosters };

            if ( games.items ) {

                games.items = games.items.map( game => {

                    if ( game.id === gameId ) {

                        game.rosterStatus = rosterStatus;

                    }

                    return game;

                } );

            }

            if ( rosters && ( gameId in rosters ) && rosters[ gameId ].items ) {

                rosters[ gameId ].items.rosterStatus = rosterStatus;

            }

            return { ...state, games, rosters };

        }

        case SIGNING_SUPPLEMENTARY_SUCCEEDED: {

            const signedAt         = action.payload.data;
            const { gameId, team } = action.payload;
            const games            = { ...state.games };
            const key              = team === 'home' ? 'supplementaryAcceptedByHomeAt' : 'supplementaryAcceptedByAwayAt';

            if ( games.items ) {

                games.items = games.items.map( game => {

                    if ( game.id === gameId ) {

                        game[ key ] = signedAt;

                    }

                    return game;

                } );

            }

            if ( games.activeItem ) {

                games.activeItem[ key ] = signedAt;

            }

            return { ...state, games };

        }

        case TAKING_FACE_CHECK_SUCCEEDED: {

            const { data, gameId } = action.payload;
            const rosters          = { ...state.rosters };

            if ( rosters && ( gameId in rosters ) && rosters[ gameId ].items ) {

                rosters[ gameId ].items = { ...rosters[ gameId ].items, ...data };

            }

            return { ...state, rosters };

        }

        default:

            return state;

    }

};

export default reducer;